import React from 'react'

function StarCircleIcon({ size = 55, fill = '#FA7C00', ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle cx="27.5" cy="27.5" r="27.5" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.2733 14.3146L32.6866 21.8587C32.721 21.9394 32.7763 22.0091 32.8467 22.0607C32.9171 22.1122 32.9999 22.1437 33.0865 22.1517L41.2437 23.0998C41.5123 23.1296 41.7666 23.2371 41.9762 23.4093C42.1859 23.5816 42.3418 23.8113 42.4254 24.0709C42.5089 24.3305 42.5165 24.6089 42.4473 24.8728C42.378 25.1366 42.2348 25.3747 42.035 25.5584L35.9874 31.1682C35.9217 31.2261 35.8727 31.3009 35.8456 31.3847C35.8186 31.4685 35.8145 31.5581 35.8338 31.644L37.4618 39.774C37.517 40.041 37.4946 40.3186 37.3973 40.5731C37.3001 40.8276 37.132 41.0483 36.9135 41.2086C36.695 41.3689 36.4352 41.462 36.1655 41.4767C35.8958 41.4914 35.6276 41.427 35.3933 41.2913L28.2423 37.2148C28.1671 37.1707 28.0816 37.1474 27.9946 37.1474C27.9075 37.1474 27.8221 37.1707 27.7468 37.2148L20.5942 41.2913C20.3598 41.4266 20.0918 41.4907 19.8223 41.4758C19.5528 41.461 19.2932 41.3678 19.0748 41.2076C18.8565 41.0474 18.6885 40.8269 18.5911 40.5725C18.4938 40.3182 18.4712 40.0409 18.5261 39.774L20.1541 31.644C20.1734 31.5581 20.1692 31.4685 20.1422 31.3847C20.1151 31.3009 20.0661 31.2261 20.0004 31.1682L13.9542 25.5577C13.754 25.3742 13.6106 25.1361 13.5412 24.8722C13.4718 24.6082 13.4793 24.3297 13.5629 24.07C13.6465 23.8102 13.8026 23.5805 14.0124 23.4082C14.2221 23.236 14.4767 23.1287 14.7455 23.0991L22.904 22.151C22.9905 22.143 23.0734 22.1116 23.1437 22.06C23.2141 22.0085 23.2694 21.9387 23.3038 21.8581L26.7158 14.3146C26.8265 14.0656 27.0061 13.8543 27.233 13.706C27.4599 13.5577 27.7243 13.4788 27.9946 13.4788C28.2648 13.4788 28.5293 13.5577 28.7561 13.706C28.983 13.8543 29.1626 14.0656 29.2733 14.3146Z"
        fill="white"
      />
    </svg>
  )
}

export default StarCircleIcon
